<template>
    <div class="layout__padding-clear">
        <div class="layout__position__relative">
            <div class="grad"></div>
            <img class="layout__width-100 layout__height-100 layout__padding-clear"
                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/studioOurWork.jpg">
            <div class="layout__padding-clear">
                <div class="component__banner-title layout__padding-clear">Our Work
                    <div class="text__size-20 text__line-height-30px layout__padding-20-0">
                        <div class="layout__padding-clear layout__width-50">
                            Ravensworth's passionate team of creatives and marketeers work hard to build exciting,
                            extraordinary brands and stunning CGI. Here you'll find just a few examples of our recent
                            projects.
                        </div>
                    </div>
                    <el-button class="button-white-grey button__base__header-large layout__width-200px" v-on:click="contactUs()">
                        Get in touch
                    </el-button>
                </div>
            </div>
        </div>

        <div class="layout__width-90 layout__padding-clear">
            <div class="layout__margin-40-0">
                <div class="component__product-3" v-on:click="showcase('bill-wych')">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/billWych/Bill-Wych-cover-.jpg" class="layout__width-100">
                    <div class="text__align-center layout__padding-20-0">
                        <div class="text__size-16 layout__padding-5-0 text__colour-teal text__style-bold-700">Design Studio</div>
                        <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Bill Wych</div>
                        <div class="text__size-16 layout__padding-5-0">Rebrand | Marketing Materials</div>
                    </div>
                </div>

                <div class="component__product-3" v-on:click="showcase('lawrence-rand')">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/lawrenceRand/lawrence-rand-cover.jpg" class="layout__width-100">
                    <div class="text__align-center layout__padding-20-0">
                        <div class="text__size-16 layout__padding-5-0 text__colour-teal text__style-bold-700">Design Studio</div>
                        <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Lawrence Rand</div>
                        <div class="text__size-16 layout__padding-5-0">Rebrand | Marketing Materials</div>
                    </div>
                </div>

                <div class="component__product-3" v-on:click="showcase('boomerang')">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/Boomerang-cover.jpg" class="layout__width-100">
                    <div class="text__align-center layout__padding-20-0">
                        <div class="text__size-16 layout__padding-5-0 text__colour-teal text__style-bold-700">Design Studio</div>
                        <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Boomerang</div>
                        <div class="text__size-16 layout__padding-5-0">Rebrand | Marketing Materials</div>
                    </div>
                </div>

                <div class="component__product-3" v-on:click="showcase('sawyde-harris')">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sawdye-harris.jpg" class="layout__width-100">
                    <div class="text__align-center layout__padding-20-0">
                        <div class="text__size-16 layout__padding-5-0 text__colour-teal text__style-bold-700">Design Studio</div>
                        <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Sawdye & Harris</div>
                        <div class="text__size-16 layout__padding-5-0">Rebrand | Marketing Materials</div>
                    </div>
                </div>

                <div class="component__product-3" v-on:click="showcase('sensier')">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/sensier-cover.jpg" class="layout__width-100">
                    <div class="text__align-center layout__padding-20-0">
                        <div class="text__size-16 layout__padding-5-0 text__colour-teal text__style-bold-700">Land & New Homes</div>
                        <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Christie’s World | Sensier</div>
                        <div class="text__size-16 layout__padding-5-0">Branding | Marketing | CGI | Design materials</div>
                    </div>
                </div>

                <div class="component__product-3" v-on:click="showcase('spinning-acres')">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/Spinning-Acres-cover.jpg" class="layout__width-100">
                    <div class="text__align-center layout__padding-20-0">
                        <div class="text__size-16 layout__padding-5-0 text__colour-teal text__style-bold-700">Land & New Homes</div>
                        <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Pickard Properties | Spinning Acres</div>
                        <div class="text__size-16 layout__padding-5-0">Branding | Marketing | CGI | Design materials</div>
                    </div>
                </div>

                <div class="component__product-3" v-on:click="showcase('connells')">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/The-point-bristol-cover.jpg" class="layout__width-100">
                    <div class="text__align-center layout__padding-20-0">
                        <div class="text__size-16 layout__padding-5-0 text__colour-teal text__style-bold-700">Land & New Homes</div>
                        <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Connells | The Point</div>
                        <div class="text__size-16 layout__padding-5-0">Branding | Marketing | CGI | Design materials</div>
                    </div>
                </div>


                <div class="component__product-3">
                    <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/pickard-coming-soon.jpg" class="layout__width-100">
                    <div class="text__align-center layout__padding-20-0">
                        <div class="text__size-16 layout__padding-5-0 text__colour-teal text__style-bold-700">Design Studio</div>
                        <div class="text__size-21 text__colour-teal text__style-bold-700 layout__padding-5-0">Pickard Properties</div>
                        <div class="text__size-16 layout__padding-5-0">Rebrand | Marketing Materials</div>
                    </div>
                </div>
            </div>
        </div>



    </div>

</template>

<script>
    import Router from '../../../router';
    import {Carousel, Slide} from 'vue-carousel';

    export default {
        name: "landnewhomes",
        props: {},
        components: {
            Carousel,
            Slide
        },
        mixins: [],
        data() {
            return {
                showPreview: false,
                testimonials: [
                    {
                        message: 'Ravensworth share our vision and passion for the industry. By walking us through designs and ideas they’ve helped us create the perfect marketing plan. They help us stand out from the crowd and their quality and attention to detail continues to impress on a daily basis.',
                        company: 'Chris Holroyd - Holroyds Estate Agents'
                    }
                ]
            }
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            },
            print() {
                Router.push({
                    name: '/products/print'
                });
            },
            digital() {
                Router.push({
                    name: '/products/print'
                });
            },
            showcase(page) {
                Router.push({
                    name: '/services/design-studio/our-work/showcase',
                    query: {
                        client: page,
                    }
                });
            }
        },
    };
</script>